import {createApp} from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";
import 'mosha-vue-toastify/dist/style.css';

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import {initApexCharts} from "@/core/plugins/apexcharts";
import {initInlineSvg} from "@/core/plugins/inline-svg";
import {initVeeValidate} from "@/core/plugins/vee-validate";


import "@/core/plugins/keenthemes";
import "@/core/plugins/prismjs";
import "bootstrap";

import Vue3Lottie from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'

import Shimmer from 'vue3-shimmer';

import VOtpInput from "vue3-otp-input";

// import VueAos from 'vue-aos'
import 'aos/dist/aos.css'

const app = createApp(App);

import Vuesax from 'vuesax3'
import 'vuesax3/dist/vuesax.css'

app.use(store);
app.use(router);
// @ts-ignore
app.use(ElementPlus);
// @ts-ignore
app.use(Vue3Lottie);
app.use(Shimmer);
app.use(VOtpInput);
// @ts-ignore
app.use(Vuesax);
// Vue.use(VueAos)

ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

import constants from "./core/constants.js";
app.config.globalProperties.$constants = constants;
app.provide('constants', constants);

import helpers from "./core/helper.js";
app.mixin({
    methods: {helpers}
});
app.config.globalProperties.$helpers = helpers;
app.provide('helpers', helpers);

app.mount("#app");
